var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-card",
        {
          staticClass: "cardClassDetailForm",
          attrs: {
            title:
              "장치 및 설비 목록 업로드 (일괄업로드는 신규로만 저장이 됩니다.)",
          },
        },
        [
          _c(
            "template",
            { slot: "card-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _vm.editable
                    ? _c("c-btn", {
                        attrs: { label: "LBLAPPLY", icon: "save" },
                        on: { btnClicked: _vm.acceptData },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c("template", { slot: "card-detail" }, [
            _c(
              "div",
              { staticClass: "col-3" },
              [
                _c("c-plant", {
                  attrs: { editable: false, type: "edit", name: "plantCd" },
                  model: {
                    value: _vm.data.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "plantCd", $$v)
                    },
                    expression: "data.plantCd",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c("c-excel-upload", {
        attrs: { editable: _vm.editable, excelUploadInfo: _vm.excelUploadInfo },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }